import UploadCard from "./UploadCard.view";

export default UploadCard;
